import { usePermissions } from '../hooks/usePermissions';

const PermissionGate = ({ 
  children, 
  permission = null, 
  permissions = [], 
  fallback = null,
  requireAll = false 
}) => {
  const { checkPermission } = usePermissions();

  const hasAccess = () => {
    if (permission) {
      return checkPermission(permission);
    }
    
    if (permissions.length > 0) {
      if (requireAll) {
        return permissions.every(perm => checkPermission(perm));
      } else {
        return permissions.some(perm => checkPermission(perm));
      }
    }
    
    return true; // If no permissions specified, allow access
  };

  if (!hasAccess()) {
    return fallback;
  }

  return children;
};

export default PermissionGate; 